// Fires page_view on every SPA route change.
// Must be placed inside a BrowserRouter (uses useLocation). Renders null.
// AppRouter.tsx has TWO BrowserRouter instances — this component is added to both.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

// Strips UUIDs and long numeric IDs so patient/org IDs never appear in GA4 page_path.
// Exported for unit testing.
export const sanitizePath = (pathname: string): string => {
    return pathname
        .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/:id')
        .replace(/\/\d{5,}/g, '/:id')
        .split('?')[0]
        .replace(/\/\//g, '/');
};

const RouteTracker = (): null => {
    const location = useLocation();

    useEffect(() => {
        trackPageView(sanitizePath(location.pathname));
    }, [location.pathname]);

    return null;
};

export default RouteTracker;
